import { Component, Input } from '@angular/core';

export type Level = 'h1' | 'h2';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent {
  @Input({ required: true }) title: string;
  @Input() level: Level = 'h1';
}
